import React from "react"
import { connectSearchBox } from "react-instantsearch-dom"
import { Search } from "@styled-icons/fa-solid/Search"

export default connectSearchBox(({ refine, ...rest }) => (
  <form className="searchform">
    <input
      type="text"
      placeholder="Search"
      aria-label="Search"
      onChange={e => refine(e.target.value)}
      {...rest}
    />
    <Search className="search-icon" />
  </form>
))
